import { render } from "./Academia.vue?vue&type=template&id=07705d89"
import script from "./Academia.vue?vue&type=script&lang=js"
export * from "./Academia.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__